import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/subscription/product-plans/', datas)
}

export const getPivotApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/subscription/product-plan-pivot-products/', datas)
}

export const updatePivotApiRecord = (id, data) => ApiService.put(`/subscription/product-plan-pivot-products/${id}/`, data)

export const createApiRecord = data => ApiService.post('/subscription/product-plans/', data)
export const getApiRecord = id => ApiService.get(`/subscription/product-plans/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/subscription/product-plans/${id}/`, data)
// export const updateApiStatus = (id, data) => ApiService.patch(`/product/product/${id}/`, data);
export const deleteApiRecord = id => ApiService.delete(`/subscription/product-plans/${id}/`)

export const getStripePlans = data => ApiService.get('/subscription/plan-list', data)

export const archiveStripePlan = data => ApiService.post(`/subscription/archive-product`, data)
